import { forwardRef, type Ref, type SVGProps } from "react";
const IconConcealFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27.8 6.4a1 1 0 0 0-1.4-.2l-2.7 2.2C13.7 2 5.6 10.1 2.5 13.7a2 2 0 0 0 0 2.6 27.2 27.2 0 0 0 5.4 5l-3.5 3a1 1 0 0 0-.2 1.3 1 1 0 0 0 .8.4 1 1 0 0 0 .6-.2l4.1-3.4 2.8-2.3 2.7-2.2 3.8-3 2.6-2.1 3.8-3.1 2.2-1.9a1 1 0 0 0 .2-1.4m-11.5 8a1.5 1.5 0 0 1 .6-2.3 3 3 0 0 0-.9-.1 3 3 0 0 0-3 3 3 3 0 0 0 .6 1.7l-2.4 2a6 6 0 0 1 9.3-7.7zm13.2-.7a34 34 0 0 0-2.6-2.8L22 15a6 6 0 0 1-6 6 5.6 5.6 0 0 1-1.2-.1l-3 2.4c8.3 2.9 15-3.8 17.7-7a2 2 0 0 0 0-2.6" />
  </svg>
);
const ForwardRef = forwardRef(IconConcealFilledSVG);
ForwardRef.displayName = "IconConcealFilled";
export { ForwardRef as IconConcealFilled };
